// extracted by mini-css-extract-plugin
export default {"window":"_2640IlAGi5naCb4xa-ISeT"};